import { agentTypes } from '../../services/agentType'

export const agentTypeOptions = [
  { label: agentTypes.prepaid.toUpperCase(), value: agentTypes.prepaid },
  { label: agentTypes.postpaid.toUpperCase(), value: agentTypes.postpaid },
]
